var permission = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		/**
		 * Bind permission buttons met changePermission function
		 */
		$(target).find('[data-permission-key] a.btn').on('click', function(e) {
			permission.changePermission(e);
		});

		/**
		 * Bind permission buttons met changePermissionGroup function
		 */
		$(target).find('[data-permission-group] a.btn[data-permission-group-val]').on('click', function(e) {
			permission.changePermissionGroup(e);
		});

	},

	/**
	 * Functie die de complete set met permissies geset in de DOM als JSON teruggeeft
	 *
	 * @param {object}
	 * @returns {string}
	 */
	getPermissionGroupJson: function(group) {
		var permissionArray = {};
		$(group).find('[data-permission-key]').each(function() {
			var key = $(this).data('permission-key');
			var val = $(this).parent().find('a.active').data('permission-val');
			permissionArray[key] = val;
		});
		var permissionJson = JSON.stringify(permissionArray);
		return permissionJson;
	},

	/**
	 * Functie die de permission JSON in de DOM in texareas opslaat
	 *
	 * @returns {void}
	 */
	setPermissionToDOM: function() {
		$('[data-permission-group]').each(function() {
			var group = $(this);
			var textarea = $(this).find('textarea');
			var permissionJSON = permission.getPermissionGroupJson(group);
			textarea.val(permissionJSON);
		});
	},

	/**
	 * Functie voor het veranderen van een individuele permissie met een update van de json in het permission veld in de DOM
	 *
	 * @param {object} e
	 * @returns {void}
	 */
	changePermission: function(e) {
		$(e.target).parent().find('a').removeClass('active');
		$(e.target).addClass('active');
		permission.setPermissionToDOM();
	},

	/**
	 * Functie om de permissie van een groep te wijzigen
	 *
	 * @param {object} e
	 * @returns {void}
	 */
	changePermissionGroup: function(e) {
		var parentButton = $(e.target);
		var parentGroup = $(e.target).closest('[data-permission-group]');
		var childButtons = $(e.target).closest('[data-permission-group').find('a');
		childButtons.removeClass('active');
		parentButton.addClass('active');
		var value = parentButton.data('permission-group-val');
		parentGroup.find('[data-permission-val=' + value + ']').addClass('active');
		permission.setPermissionToDOM();
	},

};

export default permission;
